export const fontFamilyPrimary =
  "'Source Sans Pro', Helvetica, Arial, sans-serif"
export const fontFamilySecondary =
  "'Palatino Linotype', 'Book Antiqua', Palatino, serif"
export const fontFamilyMonospace =
  "Menlo, Monaco, Consolas, 'Lucida Console', monospace"

export const fontSize = '1em'
export const fontSizeH1 = '2em'
export const fontSizeH2 = '1.5em'
export const fontSizeH3 = '1.17em'
export const fontSizeH4 = '1em'
export const fontSizeH5 = '0.83em'
export const fontSizeH6 = '0.67em'
